















import { Component, Vue } from "vue-property-decorator";
import { Circle2 } from "vue-loading-spinner";
import { fileOpen, fileDownload } from "@/file-utils";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import ShiftFilter from "@/layouts/DashboardLayoutComponents/ShiftFilter.vue";

import reportModel from "@/models/report.model";

@Component({
	components: {
		ShiftFilter,
		PaginatedSearch,
		Circle2,
	},
})
export default class TotalHoursValueReport extends Vue {
	shiftModel: any;
	shiftFilter: Record<string, any> = {};
	shiftId: any = null;
	fileDownloading = false;

	constructor() {
		super();
	}

	updateFilter(filter: any)  {
		this.shiftFilter = filter;
	}

	async getReport(kind: "DOWNLOAD" | "OPEN") {

		if (!this.validateForm()) {
			return
		}

		this.fileDownloading = true;
		try {
			const pdfBlob = await reportModel.getSumOfHoursAndPayments({ startDateTime: this.shiftFilter.startDateTime, unitId: this.shiftFilter.unit  });
			if (kind === "DOWNLOAD") {
				fileDownload(pdfBlob, 'relatorio-total-horas-x-valor.pdf');
			} else if (kind === "OPEN") {
				fileOpen(pdfBlob);
			}
		} catch (error) {
			this.$toasted.error(error.friendlyMessage || 'Não foi possível gerar o relatório. Tente novamente.');
			console.error(error);
		}
		this.fileDownloading = false;
	}

	validateForm(): boolean {
		if (this.shiftFilter && !this.shiftFilter.unit) {
			this.$toasted.error('É necessário selecionar uma unidade para gerar o relatório');
			return false
		}
		return true
	}
}
